import { notification } from "antd";
const openNotificationWithIcon = (
  type,
  title,
  message,
  placement = "topRight"
) => {
  notification[type]({
    message: title,
    description: message,
    placement,
  });
};

export default openNotificationWithIcon;
